import styles from './MasterProcessInput.module.scss';
import {FC, useCallback} from 'react';
import {MasterProcessItemModel} from '../common/MasterProcessItemModel';
import {IndustryDto} from '../../../../services/generated';
import {DictionaryMultiselectDropdown} from '../../../common/DictionaryDropdown/DictionaryMultiselectDropdown';

interface IMasterProcessInputIndustryProps {
  model: MasterProcessItemModel;
  options: IndustryDto[] | null;
  disabled?: boolean;
}

export const MasterProcessInputIndustry: FC<IMasterProcessInputIndustryProps> = ({
  model,
  options,
  disabled
}) => {
  const onChange = useCallback(
    (value: IndustryDto[] | undefined) => (model.industries = value || null),
    [model]
  );
  return (
    <DictionaryMultiselectDropdown
      className={styles.input}
      options={options}
      onChange={onChange}
      defaultValues={model.industries}
      disabled={disabled || !model.isChecked}
    />
  );
};
